export default {"src":"/vendor/_next/static/media/favicon.d5a6a16b.ico","height":64,"width":64,"blurWidth":0,"blurHeight":0};